import styled from "styled-components";

export const TaxTitle = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.5px;
  color: #022737; 
  margin-bottom: 21px;
`;
